/* STRYP Elevation Layer JS — reveal-on-scroll + stat count-up. No deps. */
(function () {
  'use strict';
  var root = document.querySelector('.stryp-homepage');
  if (!root) return;
  var motionOK = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Reveal-on-scroll: tag major section children */
  if (motionOK && 'IntersectionObserver' in window) {
    var targets = root.querySelectorAll(
      '.stryp-how__step, .stryp-indict__stats > div, .stryp-card, .stryp-plan, .stryp-quote, ' +
      '.stryp-system__benefits li, .stryp-guarantee__inner, .stryp-faq__item, .pdp-stat'
    );
    targets.forEach(function (el, i) {
      el.classList.add('elv');
      el.style.transitionDelay = (i % 3) * 70 + 'ms';
    });
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    targets.forEach(function (el) { io.observe(el); });
  }

  /* 2. Count-up for Indictment stats (700M, 90%, 1956) */
  function countUp(el) {
    var raw = el.textContent.trim();
    var m = raw.match(/^([0-9,.]+)(.*)$/);
    if (!m) return;
    var end = parseFloat(m[1].replace(/,/g, ''));
    var suffix = m[2] || '';
    var start = end > 1000 ? Math.floor(end * 0.9) : 0; /* years ease in from 90% */
    var dur = 1200, t0 = null;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var val = Math.round(start + (end - start) * eased);
      el.textContent = val + suffix;
      if (p < 1) requestAnimationFrame(step); else el.textContent = raw;
    }
    requestAnimationFrame(step);
  }
  if (motionOK && 'IntersectionObserver' in window) {
    var nums = root.querySelectorAll('.stryp-indict__num');
    if (nums.length) {
      var seen = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { countUp(e.target); obs.unobserve(e.target); }
        });
      }, { threshold: 0.6 });
      nums.forEach(function (el) { seen.observe(el); });
    }
  }
})();
